import React from 'react';
import img_recruit_01 from 'image/recruit/recruit-01.png';
import img_recruit_02 from 'image/recruit/recruit-02.png';

const _dataTeam = [
  {
    id: 1,
    name: "가공팀",
    image: img_recruit_01,
    text: "동구밭 팩토리에서 생산된 비누를 가공하여 정량의 제품으로 만드는 일은 가꿈지기 가공팀에서 하고 있습니다. 꼼꼼하고 정확하게 반복적인 일을 잘 수행해내는 발달장애인 사원이 일하기에 적합한 부서입니다. 건조된 비누를 정해진 중량에 맞게 성형하고, 잘못된 제품을 찾아내는 업무를 수행합니다.",
    work: ["비누성형", "작업 준비", "작업장 정리 및 청소", "박스 및 원료 옮기기 등"]
  },{
    id: 2,
    name: "포장팀",
    image: img_recruit_02,
    text: "생산 가공된 제품을 고객에게 전달하기 위해 깨끗하고 보기 좋게 제품을 포장하고, 납품하는 일까지 책임감 있게 해주는 일은 가꿈지기 포장팀에서 일하게 됩니다. 대량 납품에서부터 개인 고객의 주문까지 정해진 제품을 포장하는 업무를 수행합니다.",
    work: ["패키지 포장", "택배 주문건 포장", "박스 접기", "작업장 정리 및 청소 등"]
  }
]

const RecruitTeam = (props) => {
  return (
    <section className={`RecruitTeam ${props.className}`}>
      <div className="con">

          <ul className="wrap-team">
            {_dataTeam.map(el => {
              return  <li className="team" key = {el.name}>
                        <h3 className="team-name">가꿈지기<br /><span className="color-main">{el.name}</span></h3>
                        <img src={el.image} alt={el.name}/>

                        <p className="team-text">{el.text}</p>

                        <ul className="wrap-text">
                          <li className="text-row">
                            <p className="bold">주요 업무</p>
                            <div className="wrap-work">
                              <ul>
                                {el.work.map((w, index) => {
                                  return <li key={index}>{index+1}. {w}</li>
                                })}
                              </ul>
                            </div>
                          </li>
                        </ul>
                      </li>
            })}
          </ul>

      </div>
      
    </section>
  );
}

export default RecruitTeam;